import { mapState } from 'vuex';
import { INSURANCE_PERMISSIONS, MY_CARE_CLIX_INFO } from '@/common/constants';

export default {
  computed: {
    ...mapState('loggedAccount', ['account', 'accountClinic', 'clinics']),
    ...mapState('booking', ['clinicAdmin']),
    isGlobeMedActive() {
      if (this.account?.role === 'PATIENT') {
        return !!this.accountClinic?.features.find(el => el.name === INSURANCE_PERMISSIONS.GLOBEMED);
      }

      if (this.account?.role === 'CLINIC_ADMIN') {
        const patientClinicId = this.clinicAdmin?.patient?.clinicIds?.[0];
        const patientClinic = this.clinics.find(clinic => clinic.id === patientClinicId);
        return !!this.clinicHasGlobeMed(patientClinic ? [patientClinic] : []);
      }

      return !!this.clinicHasGlobeMed(this.clinics);
    },
    isMyGuardianDocActive() {
      if (!this.clinics.length) return null;
      return !!this.clinics.find(item => MY_CARE_CLIX_INFO.CLINIC_IDS.ALL.includes(item.id));
    },
  },
  methods: {
    clinicHasGlobeMed(clinics) {
      return clinics.find(clinic => clinic.features.find(el => el.name === INSURANCE_PERMISSIONS.GLOBEMED));
    },
    checkClinicOnMyGuardianDoc(clinic) {
      return MY_CARE_CLIX_INFO.CLINIC_IDS.ALL.includes(clinic?.id);
    },
    checkClinicOnMyGuardianDocMain(clinic) {
      return MY_CARE_CLIX_INFO.CLINIC_IDS.MAIN.includes(clinic?.id);
    },
    checkClinicOnMyGuardianDocBusiness(clinic) {
      return MY_CARE_CLIX_INFO.CLINIC_IDS.BUSINESS.includes(clinic?.id);
    },
    checkSubscriptionForAnyMyGuardianDoc({ redirect = true, listOfClinicIds = MY_CARE_CLIX_INFO.CLINIC_IDS.ALL }) {
      if (this.account?.role !== 'PATIENT' || !listOfClinicIds.includes(this.clinics[0]?.id)) return true;

      const isActive = !!this.account?.subscription;

      if (!isActive && redirect) this.$router.push('/profile/subscriptions');

      return isActive;
    },
    checkSubscriptionForMyGuardianDoc(redirect = true) {
      return this.checkSubscriptionForAnyMyGuardianDoc({ redirect });
    },
    checkSubscriptionForMyGuardianDocMain(redirect = true) {
      return this.checkSubscriptionForAnyMyGuardianDoc({ redirect, listOfClinicIds: MY_CARE_CLIX_INFO.CLINIC_IDS.MAIN });
    },
    checkSubscriptionForMyGuardianDocBusiness(redirect = true) {
      return this.checkSubscriptionForAnyMyGuardianDoc({ redirect, listOfClinicIds: MY_CARE_CLIX_INFO.CLINIC_IDS.BUSINESS });
    },
  },
};
